import { initialListPaginationMeta } from "utils/helpers/pagination";

import { RoofMaterialTypeForm, RoofMaterialTypeState } from "../types";

export const initialRoofMaterialTypeForm: RoofMaterialTypeForm = {
  materialTypeDesc: "",
};

export const initialRoofMaterialTypeMeta = initialListPaginationMeta;

export const initialState: RoofMaterialTypeState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialRoofMaterialTypeMeta,
  error: null,
  isAddModalOpen: false,
  form: initialRoofMaterialTypeForm,
  detail: null,
  detailLoading: false,
  detailError: null,
};
